export default __webpack_public_path__ + "static/media/Binding Chains.9eda2f07.png";